import styled from "@emotion/styled";

export const TooltipTime = styled.time`
  color: var(--mb-color-text-medium);
  font-size: 0.875em;
`;
